import { getCalApi } from "@calcom/embed-react";
import { CAL_NAMESPACE, CAL_LINK, CAL_BRAND_COLOR } from "./config";

export { CAL_NAMESPACE, CAL_LINK };

// Précharge le booking cal.com (connexion + assets) pour une ouverture instantanée.
export async function preloadCal() {
  try {
    const cal = await getCalApi({ namespace: CAL_NAMESPACE });
    cal("ui", {
      cssVarsPerTheme: {
        light: { "cal-brand": CAL_BRAND_COLOR },
        dark: { "cal-brand": CAL_BRAND_COLOR },
      },
      hideEventTypeDetails: false,
      layout: "month_view",
    });
    cal("preload", { calLink: CAL_LINK });
  } catch {
    /* préchargement best-effort */
  }
}

// ---------------------------------------------------------------------------
// Lecture de la réservation remontée par l'embed (event `bookingSuccessful`).
//   `bookingSuccessfulV2` ne porte ni nom ni email ; l'ancien event les porte
//   dans `booking` (réponse de l'API de création). Lecture défensive : si la
//   forme change côté cal.com, on garde au moins ce qu'on a pré-rempli.
// ---------------------------------------------------------------------------
import type { BookingLead } from "./lead";

const str = (v: unknown) => (typeof v === "string" && v.trim() ? v.trim() : undefined);

export function readCalBooking(data: unknown, fallback: BookingLead = {}): BookingLead {
  const b = ((data as any)?.booking ?? {}) as Record<string, any>;
  const r = (b.responses ?? {}) as Record<string, any>;
  const a = (Array.isArray(b.attendees) ? b.attendees[0] : undefined) ?? {};
  const name = typeof r.name === "object" && r.name
    ? [r.name.firstName, r.name.lastName].filter(Boolean).join(" ")
    : r.name;
  return {
    name: str(name) ?? str(a.name) ?? fallback.name,
    email: str(r.email) ?? str(a.email) ?? fallback.email,
    phone: str(r.attendeePhoneNumber) ?? str(r.phone) ?? str(a.phoneNumber) ?? fallback.phone,
    startTime: str(b.startTime) ?? str((data as any)?.date),
    endTime: str(b.endTime),
    uid: str(b.uid),
  };
}
